<template>
  <div v-if="show">
    <div id="payment-heading-container" fullscreen persistent transition="fade-transition">
      <div class="menu-card ">
        <div class="py-3 text-center">
          <h3 class="balance-text"> {{ prompt.headerPaymentSelection }} :: {{ prompt.headerBalanceDue }}<span style="font-weight:600;font-size:1.25em;"> {{ currency(balanceDue) }}</span></h3>
        </div>
        <div class="big-spacer mb-2"></div>
      </div>
    </div>
  <div class="row" style="height:100%;align-items:stretch;">
      <!-- Select Tendering Key -->
      <div class="col-sm-12 col-md-6 col-lg-8 col-xl-8 mt-3 pl-5" v-if="activeForm === 'askpayment'" >
        <h4>Select Payment Type</h4>
        <div class="text-center mt-4">
          <div class="payment-type-grid">
            <div v-for="(tender, index) in activeTenderMedia()" :key="index"  class="payment-type-btn-wrapper" >
              <b-button class="payment-type-btn"  :class="tender.class"  @click="selectTender(tender)" block >
                <div class="payment-type-content">
                  <i :class="tender.icon" class="payment-type-icon"></i>
                  <span class="payment-type-label">{{ tender.title }}</span>
                </div>
              </b-button>
            </div>
          </div>
        </div>
        <hr>
        <b-button class="bg-white text-dark border-primary form-cancel-btn mt-2" @click="cancel()">Back</b-button>
      </div>

      <!-- Ask Card -->
      <div class=" col-12 col-lg-8 col-md-11 mt-3" v-if="activeForm === 'askcard'">
        <b-form class="badge-information p-3" @keydown.esc="cancelLookup()">
          <h4 class="font-weight-bolder pb-2 text-center">{{ selectedTender.title }}</h4>
          <b-form-group class="font-weight-bold pb-3" id="input-group-1" :label="selectedPayment.prompt.cardNumber" label-for="input-1">
            <b-input class="badge-information-input" id="input-1" ref="cardinput" type="text" autofocus autocomplete="off" placeholder=""
              v-on:keydown.13.prevent="lookupCard('byBadge')" v-model="cardNumber"></b-input>
          </b-form-group>
          <div class="mt-4" v-if="errorMessage">
            <b-alert variant="danger" show>{{ errorMessage }}</b-alert>
          </div>
          <b-button variant="" @click="cancelLookup()" class="bg-white charge-button float-left text-dark border-primary form-cancel-btn" style="min-width: 110px">Cancel</b-button>
          <b-button @click="searchName()" class="form-submit-btn ml-2 charge-button" style="min-width: 110px">{{ prompt.searchName }}</b-button>
          <b-button @click="lookupCard('byBadge')" class="form-submit-btn ml-2 charge-button" style="min-width: 110px">{{ prompt.searchBadge }}</b-button>
        </b-form>
      </div>

      <!-- Ask Account -->
      <div class="col-12 col-lg-8 col-md-11 mt-3" v-if="activeForm === 'askaccount'">
        <div class="account-list-container">
          <template v-if="account">
            <AccountTile :account="account" />
            <!-- <div class="account-button" style="margin-left:2em;">
              <div class="row" @keydown.esc="cancelLookup()">
                <div class="col-12 col-md-4">
                  <div class="account-button-image-container">
                    <span v-if="account.badge.pictureUrl"><img :src="account.badge.pictureUrl" /></span>
                    <span v-else><i class="fa fa-user user-icon"></i></span>
                  </div>
                </div>
                <br />
                <div class="col-12 col-md-8">
                  <div style="font-weight:800;font-size:1.2em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                    {{ account.badge.alias }}
                  </div>
                  <div>{{ account.accountTitle }}</div>
                  <div v-if="account.roomNumber">Room: {{ account.roomNumber }}</div>
                  <div style="font-size:.8em;">{{ account.accountNumber }}</div>
                </div>
              </div>
            </div> -->
          </template>
          <template v-if="!account">
            <div class="row">
              <div
                v-for="(acct, index) in accounts"
                :key="index"
                class="col-md-4 col-sm-6 col-xs-12 pl-3"
              >
                <AccountTile :account="acct" @select="selectAccount" />
              </div>
            </div>
          </template>
        </div>
        <!-- Status Legend -->
        <div v-if="!account && statusLegend.length" class="status-legend ">
          <span v-for="flag in statusLegend" :key="flag.key" class="mr-3" style="display:inline-flex;align-items:center;">
            <i :class="flag.icon" :style="flag.style" :title="flag.label"></i>
            <span style="margin-left:0.5em;font-size:0.95em;">{{ flag.label }}</span>
          </span>
        </div>
        <br />
        <div class="mt-2 p-5" v-if="errorMessage">
          <b-alert variant="danger" show>{{ errorMessage }}</b-alert>
        </div>
        <b-button variant="" @click="cancelLookup()" class="bg-white text-dark border-primary form-cancel-btn ml-1 mt-1">Back</b-button>
      </div>

      <!-- Select Total -->
      <div class="col-lg-8 col-md-11 mt-2 col-12 text-right mt-2" v-if="activeForm === 'selecttotal'">
        <div style="margin:0 0 1em 0;padding:0 0 1em 0;border-bottom:2px solid gray;">
          <img v-if="account.badge.pictureUrl" :src="account.badge.pictureUrl" style="border-radius:25%;" height="96" />
          <i v-else style="text-align:left;font-size:96px;" class="fa fa-user user-icon"></i>
          <div>
            <h4 style="margin:0;">{{ account.accountTitle }}</h4>
            <div>{{ account.badge.lastName }}, {{ account.badge.firstName }}</div>
          </div>
        </div>
        <div style="display:inline-flex;width:100%;margin-bottom:1em;" @click="askPostingAmount()">
          <div style="width:100%;font-size:1.25em;text-align:center;">
            Posting Amount: <span style="font-weight:800;font-size:1.1em;">{{ currency(postingAmount) }}</span> <span>{{
              currency(balanceDue).subtract(postingAmount) == 0 ? "" : "(partial tender)" }}</span>
          </div>
        </div>
        <div v-if="matchingTotals().length > 0">
          <b-button class="total-select-button" style="width:80%;margin-right:10%;" @click="selectTotal(ttl)" v-for="(ttl, index) in matchingTotals()" :key="index"
            :disabled="availableBalance(ttl) == 0">
            <div v-if="availableBalance(ttl) == 0" style="color:red;font-size:1.2em;margin-bottom:.5em;">
              {{prompt.noValueRemaining}}
            </div>
            <i class="fa fa-university"></i> Posting <span style="font-weight:700;">{{ currency(postingAmount) }}</span> on <span style="font-weight:700;">{{ ttl.title }}</span> 
            <div v-if="ttl.balance" style="margin-top:.5em;"> Current Bal: {{ currency(ttl.balance)}} 
              <span style="padding-left:.5em;font-size:.8em;">(before posting)</span>
              <span v-if="balanceDue > availableBalance(ttl)" style="background:red;color:white;padding:.25em .5em;border-radius:.5em;margin-left:2em;">(available {{currency(availableBalance(ttl)) }})</span>
            </div>
          </b-button>
        </div>
        <div v-else>
          <h4 style="color:red;">{{ prompt.notAvailableHere }}</h4>
        </div>
        <b-button class="bg-white text-dark border-primary form-cancel-btn mt-4" @click="cancelLookup()">Cancel</b-button>
      </div>

      <!-- Confirm Post -->
      <div class="col-lg-6 col-md-10 col-12 col-sm-10 offset-sm-1 mt-2" v-if="activeForm === 'afterPostVerify'">
        <div class="row posting-card">
          <div class="col-12 text-center mb-2">
            <h5>{{ selectedTender.title }}<span style="font-size:.7em;"> to </span>{{ total.title }} Total</h5>
          </div>
          <div class="col-4">
            <img v-if="account.badge.pictureUrl" style="display:block;margin:auto;max-height: 120px;border-radius:1em;"
              :src="account.badge.pictureUrl" />
            <i v-else style="display:block;text-align:center;margin:auto;font-size:120px;" class="fa fa-user user-icon"></i>
          </div>
          <div class="col-8 form-verify" style="font-size:.7em;font-weight:100;padding-right:3em;line-height:1.5em;">
            <table>
              <thead>
                <td style="background:orange;width:150px;text-align:right;height:3px;"></td>
                <td style="background:blue;width:250px;"></td>
              </thead>
              <tbody>
                <tr>
                  <td style="text-align:right;padding-right:.5em;">Name</td>
                  <td style="padding:1em 0;font-size:2em;font-weight:600;"><span>{{ account.badge.alias }}</span></td>
                </tr>
                <tr v-if="account.roomNumber">
                  <td style="text-align:right;padding-right:.5em;">Room #</td>
                  <td style="font-size:1.25em;font-weight:600;"><span>{{ account.roomNumber }}</span></td>
                </tr>
                <tr>
                  <td style="text-align:right;padding-right:.5em;">Badge Name</td>
                  <td style="font-size:1.25em;font-weight:600;"><span>{{ account.badge.lastName }}, {{ account.badge.firstName }}</span></td>
                </tr>
                <tr>
                  <td style="text-align:right;padding-right:.5em;">Account Name</td>
                  <td style="font-size:1.25em;font-weight:600;">{{ account.accountTitle }}</td>
                </tr>
                <tr>
                  <td style="text-align:right;padding-right:.5em;">Current Balance</td>
                  <td style="font-size:1.25em;font-weight:600;">{{ currency(total.balance) }}</td>
                </tr>
                <tr>
                  <td style="text-align:right;padding-right:.5em;">Posted</td>
                  <td style="font-size:1.5em;font-weight:900;">{{ currency(postingAmount) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row posting-card mt-1">
          <div v-if="['success', 'partial'].indexOf(currentPaymentStatus) < 0" class="col-12">
            <div class="col-12 text-center">
              <h5>Posting Confirmation</h5>
            </div>
            <b-button class="bg-white text-dark border-primary form-cancel-btn mt-2 w-100" @click="cancelLookup()">Cancel</b-button>
            <b-button @click="postTransaction()" v-if="!errorMessage" class="form-submit-btn mt-2 w-100">OK, Post It</b-button>
          </div>
          <div class="mt-2 w-100 text-center show-hand p-4" @click="errorMessage=''" v-if="errorMessage">
            <b-alert 
              variant="danger"
              :show="!!errorMessage"
              dismissible
              @dismissed="errorMessage = ''"
              class="w-100"
            >
              {{ errorMessage }}
            </b-alert>
          </div>
          <div class="mt-2 col-12" v-if="currentPaymentStatus">
            <b-alert variant="success" :show="currentPaymentStatus === 'success'" class="w-100"><span v-if="currentPaymentStatus === 'partial'">PARTIAL </span>
              Payment Complete</b-alert>
            <b-alert variant="danger" :show="currentPaymentStatus === 'failed'" class="w-100">{{ errorMessage }}</b-alert>
            <b-button v-if="currentPaymentStatus === 'partial'" @click="continueTender()" class="form-submit-btn w-100">Partial Tender Complete, Let's
              Continue</b-button>
            <div v-if="currentPaymentStatus != 'partial'" class="d-flex justify-content-between align-items-center mt-2">
              <b-button @click="printReceipt" class="btn btn-info" style="min-width: 160px;">Print Receipt</b-button>
              <b-button @click="goToHome()" class="btn btn-success ml-2" style="min-width: 120px;">Done/Continue</b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 d-none d-sm-none d-md-block d-lg-block d-xl-block pr-4" style="height:100%;min-height:0;display:flex;flex-direction:column;">
        <order-receipt :orderDetails="transaction" :sortReceipt="options.sortReceipt" style="flex:1 1 auto;min-height:0;" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

/************************************************************************************************
 **                                        NOTES                                               **
 ************************************************************************************************

  This posting sequence is becasue of the following:

  We ask for a "badge" (card) number

  A badge can belong to more than 1 account
  An account can have more than 1 total

  Each of these sections have limits and status to be verified before posting -
  while this is NOT necessarily required, it is much faster to do the preliminary
  verification at the client to keep the round-trips to the server to a min
  and provide a better user experience.

*/

import Currency from 'currency.js'
import GeneralService from '@/services/GeneralService'
import _ from 'lodash'
import OrderReceipt from '@/components/OrderReceipt'
import AccountTile from '@/components/AccountTile.vue'

export default {
  name: 'PaymentDialog',
  components: {
    OrderReceipt,
    AccountTile
  },
  props: {
    showDialog   : { type: Boolean, required: true, default: false },
    prompt       : { type: Object, default: () => {}, required: true },
    tenderMedia  : { type: Array, default: () => [] },
    paymentType  : { type: Array, default: () => [] },
    transaction  : { type: Object, default: () => {} },
    options      : { type: Object, default: () => {} },
    isAdmin      : { type: Boolean, default: true },
    paymentStatus: { type: String, default: null },
    configItems  : { type: Array, default: () => [] }
  },
  data () {
    return {
      loading            : false,
      errorMessage       : "",
      activeForm         : 'askpayment',
      cardNumber         : '',
      accounts           : null,
      account            : null,
      totals             : null,
      total              : null,
      postingAmount      : 0,
      selectedPayment    : null,
      selectedPaymentType: null,
      selectedTender     : null,
      localPaymentStatus : null, // Local copy of paymentStatus prop
      creditCardTemplate : {},
      postingTemplate: {
        accountNumber: "",
        badgeNumber  : "",
        revenueCenter: 0,
        tenderNumber : 0,
        tenderAmount : 0,
        tenderQty    : 1,
        totalClassId : 0,
        title        : 'sale',
        isPayment    : false,
        isMealPlan   : false,
        servingPeriod      : 0,
        transactionNumber  : 0,
        checkNumber        : "",
        coverCount         : 1,
        transactionEmployee: 0,
        checkEmployee      : 0,
        terminalNumber     : 0,
        comment: "",
        transactionTotal: 0,
        salesItemizer: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
        taxItemizer  : [0,0,0,0],
        discount     : 0,
        serviceCharge: 0,
        previousPay: 0,
        items: []
      },
      postingItem: null,
      tenderItem: null,
      tenderTemplate: {
        itemNumber : 0,
        sequence   : 9999999,
        title      : '',
        category   : 'tender',
        priceLevel : 0,
        itemType   : 'tender',
        description: '',
        reference  : [],
        void       : false,
        itemOptions: {
          isTaxable: false
        },
        qty: 1,
        price: 0.00
      }
    }
  },
  computed: {
    show () {
      this.activeForm = 'askpayment';
      return this.showDialog
    },
    balanceDue () {
      return Currency(this.transaction.total).subtract(this.transaction.amountPaid).value
    },
    currentPaymentStatus() {
      return this.localPaymentStatus;
    },
    statusLegend() {
      if (!this.accounts || !Array.isArray(this.accounts)) return [];
      const statusMap = [
        { key: 'isOnHold',    icon: 'fa fa-pause-circle',      style: 'color: red;', label: 'On Hold' },
        { key: 'isVIP',       icon: 'fa fa-star',              style: 'background:gold;color: white;border-radius:50%;padding:.25em;', label: 'VIP' },
        { key: 'isMinor',     icon: 'fa fa-child',             style: 'color: orange;', label: 'Minor' },
        { key: 'isOffSite',   icon: 'fa fa-cloud',             style: 'color: red;', label: 'Off Site' },
        { key: 'isOnLeave',   icon: 'fa fa-plane-departure',   style: 'color: firebrick;', label: 'On Leave' },
        { key: 'isParent',    icon: 'fa fa-user-plus',         style: 'color: #28a745;', label: 'Parent' },
        { key: 'isGuest',     icon: 'fa fa-user-secret',       style: 'color: green;', label: 'Guest' },
      ];
      const present = {};
      for (const acct of this.accounts) {
        if (!acct.badge || !acct.badge.status) continue;
        for (const s of statusMap) {
          if (acct.badge.status[s.key]) present[s.key] = true;
        }
      }
      return statusMap.filter(s => present[s.key]);
    }
  },

  watch: {
    showDialog(newVal) {
      if (newVal) {
        // Dialog is being shown: put your activation logic here
        let tm = this.activeTenderMedia();
        if (tm.length == 1) {
          let tm0 = tm[0];
          let t = this;
          this.$nextTick(() => {this.selectTender(tm0);});
        }
      }
    },
    isAccountFormShow () {
      if (!this.showDialog) {
        this.resetValues()
      }
    },
    paymentStatus: {
      immediate: true,
      handler(newValue) {
        this.localPaymentStatus = newValue;
        if (this.localPaymentStatus === 'failed' || this.localPaymentStatus === 'partial') {
          this.loading = false;
        } else if( this.localPaymentStatus === 'success'  ) {
          
          if( this.selectedTender && this.selectedTender.options && !this.selectedTender.options.isPauseAfterPosting ) {    // we check this one more time.
            let t = this;
            setTimeout(() => {t.loading = false;t.goToHome();}, 750);
          }
        }
      }
    }
  },

  methods: {
    activeTenderMedia() {
      return _.sortBy(this.tenderMedia, "sequence");
    },
    goToHome () {
      let goHome = false;
      if (this.currentPaymentStatus === 'success') {

        if( this.selectedTender.options.isExitSalesScreen ) {
          goHome = true;
        }

        this.$emit('resetTransaction');
        this.resetValues();           // this resets the selectedTender -- HA!

        if( goHome ) {
          this.$emit( "home" );
        }

      } else if (this.currentPaymentStatus === 'failed') {
        this.activeForm = 'askpayment';
        this.resetCardInformation();
      }

    },
    continueTender() {
      this.calcPostingAmount();
      this.updatePaymentStatus(null);
      this.activeForm = "selecttotal";
    },
    tbd () {
      alert('To be developed')
    },
    getConfig( tableId, key ) {
      let c = _.find( this.configItems , {tableId: tableId, key:key });
      if( ! c ) {
        return "";
      }
      return c.value;
    },
    accountListStyle( a ) {
      if( !a.accountNumber) {
        return "";
      }
      let parts = a.accountNumber.split("-");
      let section;
      if( parts.length > 1 ) {
        section = parts[0];
      } else {
        if( parts[0].indexOf( "@" ) > 0 ) {
          section = "email"
        }
      }
      let style = this.getConfig( "account-list", section );
      return style;
    },
    availableBalance( ttl ) {
      if( !ttl.limits ) {
        return 0;
      }
      let available;
      if( ttl.totalType === 'credit' ) {
        available = Currency(ttl.limits.total).subtract(ttl.balance).value;
        if( available > 0) {
          return available;
        }
      } else {
        available = Currency(ttl.limits.total).add(ttl.balance).value;
        if( available > 0  ) {
          return available;
        }
      }
      return 0;
    },
    calcPostingAmount() {
      this.postingAmount = this.balanceDue;
    },
    askPostingAmount()  {
      this.postingAmount = this.balanceDue;
    },
    resetCardInformation() {
      this.cardNumber = '';
      this.selectedPaymentType = null;
      this.account = null;
    },
    resetValues() {
      this.resetCardInformation();
      this.activeForm     = null;
      this.total          = null
      this.tenderItem     = null
      this.postingItem    = null
      this.selectedTender = null
    },
    showErrorMessage(message) {
      this.errorMessage = message;
    },
    updatePaymentStatus(status) {
      this.localPaymentStatus = status;
      this.$emit('update:paymentStatus', status);
    },
    async printReceipt() {
      // Pass the transaction receipt if available, otherwise let PosMain handle it
      const receipt = this.transaction && this.transaction.receipt ? this.transaction.receipt : null;
      this.$emit( "receipt" , receipt  );
    },
    buildPostingItem() {
      let trans      = this.transaction
      let tender     = this.selectedTender
      let tenderItem = this.tenderItem
      let account    = this.account
      let total      = this.total
      let item = Object.assign({}, this.postingTemplate)
      item.accountNumber       = account.accountNumber
      item.badgeNumber         = account.badge.badgeNumber
      item.revenueCenter       = trans.revenueCenter
      item.tenderNumber        = tender.itemNumber
      item.tenderAmount        = tenderItem.price
      item.tenderQty           = tenderItem.qty
      item.totalClassId        = total.totalClassId
      item.title               = tender.title
      item.transactionNumber   = trans.transactionNumber
      item.checkNumber         = trans.checkNumber
      item.transactionEmployee = trans.employeeNumber
      item.checkEmployee       = trans.employeeNumber
      item.servingEmployee     = trans.employeeName
      item.workstationNumber   = trans.workstationNumber
      item.wksId               = trans.workstationNumber
      item.cashierNumber       = trans.cashierNumber
      item.transactionTotal = trans.total
      item.salesItemizer =  [trans.taxable+trans.nonTaxable,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      item.taxItemizer = trans.tax
      item.discount = trans.discount
      item.serviceCharge = trans.serviceCharge
      item.previousPay = trans.amountPaid
      if (item.tenderAmount >= trans.total) {
        item.items = _.cloneDeep(trans.items);
      }
      this.postingItem = item;
      return this.postingItem;
    },
    buildTenderItem() {
      let tender = this.selectedTender
      let item = Object.assign({}, this.tenderTemplate)
      item.itemNumber = tender.itemNumber
      item.title      = tender.title
      item.price = Currency(this.postingAmount).value;
      
      this.tenderItem = item
      return this.tenderItem;
    },
    verifyTransaction() {},
    verifyBadge(badge) {
      if (!badge.active) { return showErrorMessage("Badge not active") }
      if (badge.satus.isOnHold) { return showErrorMessage("Badge is on hold") }
      if (badge.satus.isOffSite) { return showErrorMessage("Badge is on hold (2)") }
      if (this.postingAmount > badge.transactionLimit) { return showErrorMessage("Over badge transaction limit") }
      return ""
    },
    verifyAccount() {
      let account = this.account
      if (this.selectedTender.accountClass.length > 0) {
        if (this.selectedTender.accountClass.indexOf(account.accountClassId) < 0) {
          return this.showErrorMessage( this.prompt.notAvailableHere + " (1)")
        }
      }
      if (!account.active) {
        return this.showErrorMessage("Account not active")
      }
      let badgeMessage = this.verifyBadge(account.badge);
      if (badgeMessage) {
        return this.showErrorMessage( badgeMessage )
      }
    },
    selectAccount( account ) {
      if (!account) {
        this.activeForm = 'askaccount'
      } else {
        this.account = account
        this.selectTotal()
      }
    },
    countMatchingTotals() {
      if (this.selectedTender.totalClass.length === 0) {
        return this.account.total.length;
      }
      return _.filter(this.account.total, (t) => { return this.selectedTender.totalClass.indexOf(t.totalClassId) >= 0 }).length;
    },
    matchingTotals() {
      if (this.selectedTender.totalClass.length === 0) {
        return this.account.total;
      }
      return _.filter(this.account.total, (t) => { return this.selectedTender.totalClass.indexOf(t.totalClassId) >= 0 })
    },
    async selectTotal(ttl) {
      this.showErrorMessage('')
      if (ttl) {
        this.total = ttl;     // if we pass a ttl in, we're posting, otherwise, we're just building up more details
      } else {
        if (this.account.total.length === 1 ) {
          this.total = this.account.total[0];
          
          // if(  this.selectedTender && this.selectedTender.options && this.selectedTender.options.isVerifyPosting) {
          // this.activeForm = 'selecttotal'
          // return;
          // }
          // we're falling through...
        } else {
          let count = this.countMatchingTotals()
          if (count === 0) {
            return this.showErrorMessage( this.prompt.notAvailableHere );
          }
          if (count === 1) {
            this.total = this.matchingTotals()[0]
            this.activeForm = 'selecttotal'
          } else {
            this.totals = this.matchingTotals()
            this.activeForm = 'selecttotal'
            return;
          }
        }
      }

      let available = this.availableBalance( this.total );
      if( available < this.postingAmount ) {
        if( Currency(available).value == 0 ) {
          return this.showErrorMessage( this.prompt.noValueRemaining );
        }
        this.postingAmount = available;
      }

      this.buildTenderItem()
      this.verifyTransaction()

      if( this.selectedTender && this.selectedTender.options && !this.selectedTender.options.isVerifyPosting ) {
        this.loading = false;
        await this.postTransaction(  );
      } 

      this.activeForm = 'afterPostVerify'
      
    },
    searchName() {
      this.lookupCard('byName');
    },
    async lookupCard(lookupMethod) {
      this.showErrorMessage('')
      this.loading = true;
      let cardNumber = this.cardNumber || "";
      if (cardNumber.length === 0) {
        if (lookupMethod === 'byName') {
          return this.showErrorMessage( "Search Value Required")
        } else {
          return this.showErrorMessage("Card Number Required")
        }
      }
      try {
        let response;
        if (lookupMethod === 'byName'){
          response = await GeneralService.lookupAccountByName(this.cardNumber, this.selectedTender.accountClass.join(","));
        } else {
          response = await GeneralService.lookupAccount(this.cardNumber);
        }
        if (response.status === 200) {
          this.accounts = response.data;
          if (this.accounts.length > 1) {
            this.account = null
            this.selectAccount()
          } else {
            this.account = this.accounts[0]
            this.selectTotal()
          }
        } else {
          this.showErrorMessage( response.data.message )
        }
      } catch (error) {
        console.log(error.message)
        this.loading = false
        this.showErrorMessage(error.message)
      }
      this.loading = false;
    },
    cancelLookup () {
      this.resetValues()
      if( this.activeTenderMedia().length != 1 ) {
        this.activeForm = 'askpayment'
      } else {
        this.cancel();
      }
    },
    selectTender(tender) {
      this.resetValues()
      this.selectedTender = tender
      this.selectedPayment = _.find(this.paymentType, { id: tender.id })
      this.errorMessage = ""
      this.activeForm = 'askcard'
      if( tender.presets && tender.presets.badgeNumber ) {
        this.cardNumber = tender.presets.badgeNumber;
        this.lookupCard('byBadge')
      }
      this.calcPostingAmount();
    },
    async postTransaction( postingAmount ) {
      if( this.loading ) {
        return;
      }
      this.loading = true;
      let posting  = this.buildPostingItem();
      let auth;

      try {
        let response = await GeneralService.transactionPost(posting);   // This is the ACTUAL transaction posting.
        auth = response.data;

        if (response.status !== 200) {
          this.loading = false;
          return this.showErrorMessage(auth.message);
        }

      } catch (error) {
        this.loading = false;
        console.log(error.message);
        return this.showErrorMessage(error.message);
      }

      this.total.balance = Currency( auth.total.total.chargeTotal ).subtract( auth.total.total.paymentTotal ).multiply( (auth.total.totalType)==='debit' ? -1 : 1).value;

      let tenderItem = this.tenderItem;    // make room for the tender authorization.
      tenderItem.reference = [];
      tenderItem.reference.push("Approved: " + auth.transactionDetail._id.slice(auth.transactionDetail._id.length - 8));
      tenderItem.reference.push(this.account.badge.badgeNumber);
      tenderItem.reference.push(this.account.badge.alias);
      tenderItem.reference.push(auth.total.title.trim() + " Bal: " + this.currency( auth.total.total.chargeTotal ).subtract( auth.total.total.paymentTotal ).multiply( (auth.total.totalType)==='debit' ? -1 : 1));
      
      this.$emit('apply', tenderItem);  

      if( this.selectedTender.options.isPrintReceipt ) {
        this.printReceipt();
      }

    },
    cancel () {
      this.$emit('cancel');
    },
    toggleDialog () {
      return !this.showDialog;
    },
    currency (c) {
      return Currency(c);
    }
  }
}
</script>
<style lang="scss" scoped>

.status-legend {
  /* margin: .25em 0 .25em 2em; */
  font-size: 1.1em;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  text-align:center;
  padding: 0.5em 0 0.5em 0;
  color: #333;
}

.nav-menu-content {
  align-items: center;
  position: fixed;
  top: 0;
  transition: .2s cubic-bezier(.25,.8,.25,1);
  width: 100%;
  z-index: 12;
  outline: none;
  background: #fff;
  overflow-y: visible; /* Allow overflow for child scrollable elements */
}
.nav-menu {
  -webkit-box-shadow: 0 11px 15px -7px rgba(0,0,0,.2), 0 24px 38px 3px rgba(0,0,0,.14), 0 9px 46px 8px rgba(0,0,0,.12);
  box-shadow: 0 11px 15px -7px rgba(0,0,0,.2), 0 24px 38px 3px rgba(0,0,0,.14), 0 9px 46px 8px rgba(0,0,0,.12);
  border-radius: 2px;
  margin: 24px;
  overflow-y: auto;
  pointer-events: auto;
  -webkit-transition: .3s cubic-bezier(.25,.8,.25,1);
  transition: .3s cubic-bezier(.25,.8,.25,1);
  width: 100%;
  z-index: inherit;
  &.nav-menu-fullscreen {
    border-radius: 0;
    margin: 0;
    height: 100%;
    position: fixed;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    top: 0;
    left: 0;
    background: #fff;
  }
}
.payment-button {
  color: white;
  width: 30%;
  padding: 1em;
  background: salmon;
  margin-left: auto;
  margin-right: auto;
  margin-top: 4px;
  border-radius: 1em;
}
.total-select-button {
  color: white;
  padding: 0.5em;
  font-size: 1.25em;
  background: hsl(116, 45%, 37%);
  margin-left: auto;
  margin-right: auto;
  margin-top: 4px;
  border-radius: 1em;
  min-height: 82px;
}
.total-select-button:hover {
  background: hsl(116, 50%, 41%);
}
/* Payment Type Selection Grid */
.payment-type-title {
  font-size: 1.25em;
  font-weight: 700;
  margin-bottom: 1.5em;
  text-align: center;
}
.payment-type-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5em 2em;
  margin-bottom: 1.5em;
}
.payment-type-btn-wrapper {
  flex: 0 1 320px;
  max-width: 340px;
  min-width: 220px;
  display: flex;
  justify-content: center;
}
.payment-type-btn {
  width: 100%;
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25em;
  font-weight: 700;
  border-radius: 1.25em;
  box-shadow: 0 2px 8px rgba(101,157,189,0.10);
  border: 2px solid #659DBD;
  background: #eaf3f8;
  color: #193628;
  margin-bottom: 0.5em;
  transition: box-shadow 0.2s, border-color 0.2s, background 0.2s;
}
.payment-type-btn:hover, .payment-type-btn:focus {
  background: #d0e6f3;
  border-color: #417ba0;
  box-shadow: 0 4px 16px rgba(101,157,189,0.18);
}
.payment-type-content {
  display: flex;
  align-items: center;
  gap: 1em;
  width: 100%;
  justify-content: center;
}
.payment-type-icon {
  font-size: 2em;
  margin-right: 0.5em;
  color: #417ba0;
}
.payment-type-label {
  font-size: 1.15em;
  font-weight: 700;
  letter-spacing: 0.5px;
}
/* Allow custom tender class to override color if defined */
.payment-type-btn.cash {
  background: #e6f7e6;
  color: #1a4d1a;
  border-color: #4caf50;
}
.payment-type-btn.credit {
  background: #f7e6e6;
  color: #7b1f1f;
  border-color: #e74c3c;
}
.payment-type-btn.charge {
  background: #f7f3e6;
  color: #7b6b1f;
  border-color: #e7c84c;
}
@media (max-width: 900px) {
  .payment-type-btn-wrapper {
    flex-basis: 100%;
    max-width: 100%;
  }
}
.payment-heading {
  font-size: 24px;
}
.balance-text {
  font-size: 22px;
}
.form-verify-image-container {
  position: relative;
  width: 120px;
  height: 120px;
  overflow: hidden;
  margin-bottom: 20px;
  .form-verify-image {
    width: 100%;
    height: 120px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.account-list-container {
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden; /* Prevent horizontal scrollbar */
  -webkit-overflow-scrolling: touch;
  padding-bottom: 20px;
  box-sizing: border-box; /* Ensure padding doesn't cause overflow */
}
.account-button {
  color: #000;
  text-align: right;
  font-size: 16px;
  background: #f3f3f3;
  padding: 0.25em 0.75em 0.25em 0;
  margin: 4px;
  border-radius: 1em;
  cursor: pointer;
  max-width: 100%; /* Prevent overflow */
  box-sizing: border-box;
  .account-button-image-container {
    width: 64px;
    overflow: hidden;
    img {
      max-width: 100%; /* Ensure images don't overflow */
      border-radius: 0.75em;
    }
    .user-icon {
      color: #659DBD;
      font-size: 64px;
    }
  }
  /* Prevent text overflow */
  div[style*="white-space:nowrap"] {
    word-break: break-word; /* Break long text */
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.badge-information {
  background-color: #f7f7f7;
  border-radius: 15px;
  .badge-information-input {
    border-radius: unset !important;
  }
}
.badge-button {
  color: white;
  width: 30%;
  padding: 1em;
  background: seagreen;
  margin-left: auto;
  margin-right: auto;
  margin-top: 4px;
  border-radius: 1em;
}
.function-button {
  width: 94%;
  font-size: 1em;
  border-radius: 1em;
  background: coral;
  padding: 1em;
  margin: 1em;
}
.form-submit-btn {
  background-color: #659DBD;
  border: 1px solid #659DBD !important;
}
.form-cancel-btn {
  border: 1px solid #659DBD !important;
}
.menu-card {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  & .menu-card__text {
    padding: 16px;
    width: 100%;
  }
  & .big-spacer {
    width: 100%;
    height: 10px;
    background: #193628;
    mix-blend-mode: normal;
    opacity: 0.1;
  }
  & .xbig-spacer {
    width: 100%;
    height: 100px;
  }
  & .menu-title {
    font-weight: bold;
    font-size: 30px;
    line-height: 41px;
    color: #193628;
    margin-top: 18px;
    margin-bottom: 50px;
  }
  & .menu-item {
    font-weight: normal;
    font-size: 18px;
    line-height: 19px;
    color: #3F464D;
    padding: 15px 0px;
    border-bottom: solid 1px #19362821;
    cursor: pointer;
  }
  & .menu-item-2 {
    font-weight: normal;
    font-size: 18px;
    line-height: 19px;
    color: #3F464D;
    padding: 15px 0px;
    border-top: solid 1px #19362821;
    cursor: pointer;
  }
  & .sign-out {
    color: red;
  }
}
.posting-card {
  background: #f5f5f5;
  border-radius: 10px;
  padding: 10px 0;
}
.row {
  flex-wrap: wrap; /* Ensure columns wrap correctly */
}
@media (max-width: 767px) {
  .account-list-container {
    max-height: 50vh;
  }
  .account-button {
    font-size: 14px;
  }
  .account-button-image-container {
    width: 48px;
    img {
      max-width: 100%;
      border-radius: 0.5em;
    }
    .user-icon {
      font-size: 48px;
    }
  }
  .pl-3 {
    padding-left: 0.5rem !important; /* Reduce padding on mobile to prevent overflow */
  }
}
@media screen and (max-width: 530px) {
  .charge-button {
    width: 100% !important;
    margin-left: 0 !important;
    margin-bottom: 10px !important;
  }
}
</style>